var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-rate',_vm._g(_vm._b({attrs:{"colors":['#FAD20C','#FAD20C','#FAD20C'],"void-color":"#D8DADD","disabled-void-color":"#D8DADD"}},'el-rate',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }